import { render, staticRenderFns } from "./coperarkmanotelrezaktarim.vue?vue&type=template&id=92c3aa66&"
import script from "./coperarkmanotelrezaktarim.vue?vue&type=script&lang=js&"
export * from "./coperarkmanotelrezaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports